// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"a9f39a78","433":"24e82451","453":"906c81ab"}[chunkId] + ".chunk.js";
};